import React from 'react'
import { useSelector } from 'react-redux'
import { CHANGE_REQUEST_TYPE } from '@laputan/core'
import { CreateChangeRequestModal } from './CreateChangeRequestModal'
import { ModalType } from '../../states/modals/ModalType.constants'

export const AddListingModal = () => {
  const { modalType } = useSelector(({ modals }: { modals: any }) => modals)
  if (modalType !== ModalType.ADD_LISTING) {
    return null
  }
  return (
    <CreateChangeRequestModal
      header="New Listing Request"
      type={CHANGE_REQUEST_TYPE.NEW_LISTING}
    />
  )
}
